import get from 'lodash/get'
import { getCurrentVariant } from './siteVariant'

function normalizeVariant(value = '') {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')
}

function parseVariantList(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => (
        get(item, 'subdomain') ||
        get(item, 'variant') ||
        get(item, 'subdomain.uid') ||
        get(item, 'subdomain.value') ||
        get(item, 'value') ||
        ''
      ))
      .map(normalizeVariant)
      .filter(Boolean)
  }

  const raw =
    typeof value === 'string'
      ? value
      : get(value, 'text', '') || get(value, 'value', '') || ''

  return String(raw || '')
    .split(',')
    .map(normalizeVariant)
    .filter(Boolean)
}

export function shouldShowItemForCurrentVariant(item, fieldPath = '') {
  const variant = normalizeVariant(getCurrentVariant())
  const source = fieldPath ? get(item, fieldPath, {}) : item
  const showOnly = parseVariantList(get(source, 'show_only_on_subdomains'))
  const hideOn = parseVariantList(get(source, 'hide_on_subdomains'))

  if (showOnly.length > 0) return showOnly.includes(variant)
  if (!variant) return true
  return !hideOn.includes(variant)
}

export function shouldShowProjectForCurrentVariant(project) {
  return shouldShowItemForCurrentVariant(project, 'primary')
}

export function filterClientsForCurrentVariant(clients = []) {
  return (clients || [])
    .map((client) => {
      const body = get(client, 'data.body', []).filter(shouldShowProjectForCurrentVariant)

      return {
        ...client,
        data: {
          ...(client?.data || {}),
          body,
        },
      }
    })
    .filter((client) => get(client, 'data.body', []).length > 0)
}

export function filterExperienceForCurrentVariant(experience = []) {
  return (experience || []).filter(shouldShowItemForCurrentVariant)
}
